import {
  FETCH_GROUPPERFORMANCE_REQUEST,
  FETCH_GROUPPERFORMANCE_SUCCESS,
} from './actions';
import GroupPerformance from './model';
import { Map } from 'immutable';

export default function groupPerformance(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_GROUPPERFORMANCE_REQUEST:
      return state.set(action.groupId, undefined);
    case FETCH_GROUPPERFORMANCE_SUCCESS:
      return state.set(action.groupId,
        GroupPerformance.create(action.payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/GroupPerformance/reducer.js